import { render, staticRenderFns } from "./MainSlideCreate.vue?vue&type=template&id=1ea54cc8&"
import script from "./MainSlideCreate.vue?vue&type=script&lang=js&"
export * from "./MainSlideCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports